import { useNavigate } from "react-router-dom";
import { isJwtExpired, timeToExpire } from '../components/authentication/checkJWT';
import config from '../config.json';
import { getDataWithBody } from './auxilarFunctions';
import { handleResponse } from './intercepter';

const TOKEN_REFRESH_THRESHOLD = 5 * 60; // 5 minutes in seconds
const TOKEN_CHECK_INTERVAL = 30000; // Check every 30 seconds

const observeJWT = (token, dispatch, reference) => {
  if (reference) {
    clearInterval(reference);
  }

  const interval = setInterval(async () => {
    const timeLeft = timeToExpire(token);
    
    if (timeLeft <= TOKEN_REFRESH_THRESHOLD) {
      try {
        const success = await dispatch.user.refreshToken();
        if (!success) {
          dispatch.session.updateShowAlert(true);
        }
      } catch (error) {
        console.error('Token refresh failed:', error);
        clearInterval(interval);
        dispatch.user.logout();
      }
    }

    if (timeLeft <= 0) {
      clearInterval(interval);
      dispatch.user.logout();
    }
  }, TOKEN_CHECK_INTERVAL);

  dispatch.session.updateTimerReference(interval);
  return interval;
};

async function postData(url = '', data = {}, jwt) {
  let headers = {
    'Content-Type': 'application/json'
  };
  
  if (jwt) {
    headers['Authorization'] = `Bearer ${jwt}`;
  }

  const response = await fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'include', // include, *same-origin, omit
    headers: headers,
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data) // body data type must match "Content-Type" header
  });

  const interceptedResponse = await handleResponse(response);
  return interceptedResponse.json();
}

async function postData2(url = '', data = {}, jwt) {
  let headers = {
    'Content-Type': 'application/json'
  };
  
  if (jwt) {
    headers['Authorization'] = `Bearer ${jwt}`;
  }

  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'include', // This is crucial for cookies
    headers: headers,
    redirect: 'follow',
    referrerPolicy: 'strict-origin-when-cross-origin',
    body: JSON.stringify(data)
  });

  return response;
}

// count model
export const user = {
  state: {
    id: null,
    username: "Strandhill Health Centre",
    email: null,
    login: null,
    access_token: null,
    profileCompleted: false,
    dashboard: null,
    lastUpload: null,
    previousYear: null,
  },

  reducers: {
    updateToken(state, payload) {
      return {
        ...state,
        id: payload.user.id,
        username: payload.user.username,
        email: payload.user.email,
        access_token: payload.access_token,
        login: true,
        profileCompleted: payload.user.profileCompleted,
        dashboard: payload.user.dashboard
      }
    }, 
    updateToken2(state, payload) {
      return {
        ...state,
        id: payload.user.id,
        username: payload.user.username,
        email: payload.user.email,
        access_token: payload.access_token,
        login: true,
      }
    },
    loginUser(state, payload) {
      // Store user data in localStorage
      localStorage.setItem('user', JSON.stringify(payload));
      return {
        ...state,
        id: payload.user.id,
        username: payload.user.username,
        email: payload.user.email,
        access_token: payload.access_token,
        login: true,
        profileCompleted: payload.user.profileCompleted,
        dashboard: payload.user.dashboard,
        lastUpload: payload.user.lastUpload,
        previousYear: payload.user.previousYear,
      }
    },
    logoutUser(state) {
      localStorage.removeItem("user"); // clear persisted data
      return { ...state, login: null };
    },
    profileUpdated(state, payload) {
      return {
        ...state,
        profileCompleted: true,
      }
    },
    dashboardUpdated(state, payload) {
      return {
        ...state,
        dashboard: payload,
      }
    },
    clearUser(state, payload) {
      return {
        ...state,
        id: null,
        username: null,
        email: null,
        access_token: null,
        login: false,
        dashboard: null
      }
    },

  },
  effects: (dispatch) => ({

    async login(payload, state) {
      const message = await postData(config.url + '/user/login', { email: payload.email, password: payload.password })
      if (message.message == "Login Successful") {
        await dispatch.user.loginUser(message);
        if (message.user.practiceDetails) {
          await dispatch.practice.update(message.user.practiceDetails);
        }
        observeJWT(message.access_token, dispatch, state.session.timerReference);
      };
      return (message.message);
    },
    async login2(payload, state) {
      const message = await postData(config.url + '/user/login', { email: "Practice56@healthmail.ie", password: 'Sh4W!Pp73c' })
      // const message = await postData(config.url + '/user/login', { email: "hamad@gmail.com", password: '123456' })
      if (message.message == "Login Successful") {
        await dispatch.user.loginUser(message);
        if (message.user.practiceDetails) {
          await dispatch.practice.update(message.user.practiceDetails);
        }
        //observeJWT(data.access_token, dispatch, state.session.timerReference);
      };
      return (message.message);
    },
    async register(payload, state) {
      const message = await postData(config.url + '/user/signup', { username: payload.username, email: payload.email, password: payload.password })
      if (!message.successMessage) {
        return ("Not registered")
      } else {
        await dispatch.user.loginUser(message.login);
        return ("Registered");
      }
    },
    async verifyOTP(payload = {}, state) {
      const headers = {
        'Content-Type': 'application/json'
      }
      const message = await fetch(config.url + '/user/verify', {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: headers,
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(payload) // body data type must match "Content-Type" header
      })
      if (message.status !== 200) {
        if (message.status === 400) {
          const response = await message.json();
          return (response.error);
        }
      } else {
        const response = await message.json();
        return (response.message);
      }
    },
    async resendOTP(payload, state) {
      const message = await postData(config.url + '/user/resendOTP', payload);
      return;
    },
    async addDashboard(payload, state) {
      const message = await postData(config.url + '/user/addDashboard', payload, state.user.access_token);
      if (message.message && message.message === "dashboard saved") {
        this.dashboardUpdated(payload.dashboard);
      }
      return;
    },
    async resetPassword(payload, state) {
      const message = await postData(config.url + '/user/newPassword', payload);
      return message.message;
    },
    async refreshToken(payload, state) {
      try {
        const response = await postData2(`${config.url}/user/refresh_token`);
        
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Refresh token failed');
        }
    
        const data = await response.json();
        
        if (data.access_token) {
          await this.updateToken2({
            access_token: data.access_token,
            user: data.user
          });
          
          if (data.user.practiceDetails) {
            await dispatch.practice.update(data.user.practiceDetails);
          }
    
          observeJWT(data.access_token, dispatch, state.session.timerReference);
          return true;
        }
        return false;
    
      } catch (error) {
        console.error('Token refresh failed:', error);
        await this.logoutUser();
        return false;
      }
    },
    async logout(payload, state) {
      try {
        const response = await postData(config.url + '/user/logout', {});
        
        // Clear interval first
        clearInterval(state.session.timerReference);

    
        // Create an array of cleanup promises
        const cleanupPromises = [];
    
        // Add user cleanup
        cleanupPromises.push(dispatch.user.logoutUser());
        cleanupPromises.push(dispatch.user.clearUser());
    
        // Add other store cleanups with checks
        if (dispatch.antibiotics && typeof dispatch.antibiotics.clearMap === 'function') {
          cleanupPromises.push(dispatch.antibiotics.clearMap());
        }
        if (dispatch.overview && typeof dispatch.overview.clearMap === 'function') {
          cleanupPromises.push(dispatch.overview.clearMap());
        }
        if (dispatch.antibioticscomparisons && typeof dispatch.antibioticscomparisons.clearMap === 'function') {
          cleanupPromises.push(dispatch.antibioticscomparisons.clearMap());
        }
        if (dispatch.audit && typeof dispatch.audit.clearMap === 'function') {
          cleanupPromises.push(dispatch.audit.clearMap());
        }
    
        // Wait for all cleanup operations to complete
        await Promise.all(cleanupPromises);
    
        return response;
      } catch (error) {
        console.error('Logout failed:', error);
        // Still try to clear user state even if logout request fails
        await dispatch.user.logoutUser();
        await dispatch.user.clearUser();
      }
    },
    async checkUsername(payload, state) {

      const response = await postData(config.url + '/user/checkUsername', payload);

      return (response.message); // parses JSON response into native JavaScript objects
    },
    async verify(payload, state) {
      return postData(config.url + '/user/verify', { token: payload.token, email: payload.email }, payload.jwttoken)
        .then(data => {
          //dispatch.user.loginUser(data);
          //observeJWT(data.access_token, dispatch, state.session.timerReference);
        });
    },
  })
};